import React from 'react';
import Circle from './Circle';

const Location = () =>
    <Circle>
        <svg fill="currentColor" focusable="false" width="18px" height="18px" x="12" y="10" viewBox="-3.63064 -66.0327 1030.76 962.035">
            <path d="M966.912 661.84l-179.121 192c-6.08008 6.48047 -14.5439 10.1602 -23.4238 10.1602h-267.12l-1.00781 66c0 16.5596 -14.3359 30 -32 30s-30 -13.4404 -30 -30l-0.975586 -66h-352.768c-17.6797 0 -32 -14.3203 -32 -32v-384c0 -17.6797 14.3203 -32 32 -32h352.336 v-450c0 -16.5596 14.3359 -30 32 -30s32 13.4404 32 30v450h267.536c8.87988 0 17.3438 3.67969 23.4082 10.1602l179.12 192c11.4717 12.3037 11.4717 31.376 0.015996 43.6796zM750.463 480h-637.968v320h637.968l149.28 -160z" />
        </svg>
    </Circle>

export default Location;